import styles from './hero.module.css'

const heroStyle = {
    hero_wrapper: `h-[400px] container mt-[10px]
                        screen-500:h-[600px] screen-500:mt-[0]
                        xl:h-[calc(100vh-85px)] 
    `,
    slide_wrpr: `w-full h-full relative`,
    overlay_image: `w-full h-full ${styles.overlay_image}`,
    slide_image_wrpr: `w-full h-full ${styles.image_wrpr} overflow-hidden`,
    slides_navigation: `flex flex-row gap-[20px] items-center absolute z-10 bottom-4 left-1/2 right-[20px] -translate-x-1/2 justify-center
                        md:flex-col md:gap-[40px] md:left-[unset] md:bottom-[unset] md:top-1/2 md:-translate-y-1/2 md:justify-start
    `,
    dot: `min-w-[8px] w-[8px] h-[8px] rounded-full bg-[#CF3256] relative ${styles.slider_dot}
            screen-500:min-w-[10px] screen-500:w-[10px] screen-500:h-[10px]
    `,
    current_index_ball: `w-[40px] h-[40px] absolute -top-2 ${styles.moving_ball} transition-all duration-300 ease-in-out`,
    explore_btn: `!py-[12px] !px-[30px] max-w-[220px] screen-500:max-w-[240px] min-[1146px]:max-w-[280px] w-full !justify-start absolute left-3 right-[unset] md:left-[unset] md:right-[0] bottom-[70px] md:bottom-[35px] flex items-center rounded-lg
    `,
    arrow_wrpr: `absolute right-[30px] screen-500:right-[45px] min-[1146px]:right-[70px] w-[25px] flex items-center overflow-hidden
                    lg:w-[30px] lg:h-[40px] 
    `,
    arrow: `w-[15px] h-[9px] ${styles.arrow_animation}
                screen-500:w-[25px] screen-500:h-[10px]
                lg:w-[30px] lg:h-[15px]
    `,
    text_wrpr: `absolute bottom-32 left-3 pr-[30px] max-w-[900px] flex flex-col gap-1
                lg:pr-[25px] lg:left-6
                md:bottom-12 md:left-10 md:pr-[40px] md:left-5
                screen-500:left-4 screen-500:gap-0
    `,
    heading: `text-[24px] font-[700] leading-[30px] pr-0 text-white font-Suisse uppercase ${styles.heading_text}
                lg:leading-[70px] lg:text-[60px]
                md:text-[40px] md:leading-[50px]
                screen-500:text-[35px] screen-500:leading-[40px]
    `,
    shaded_heading: `text-primaryHeading text-stroke-white`,
    description: `text-[14px] font-[300] leading-[15px] max-w-[600px]
                  screen-500:text-[18px] screen-500:font-[400] screen-500:leading-[normal]
                  md:text-[25px]
    `,
}

export { heroStyle }